import React from "react";
import styles from "../Styles/Sections.module.css";
import mobileImgShop from "../../Visualizing/LandingPage/ShopWoolit.png";
import mobileImageOppskrift from "../../Visualizing/LandingPage/OppskriftPrototype.png";
import verticalLine from "../../Visualizing/LandingPage/VerticalLine.png";
import arrow from "../../Visualizing/LandingPage/arrow.svg";
import { useTranslation } from "react-i18next";

function WoolitShopSection() {
  const { t } = useTranslation();
  return (
    <div className={styles.woolitShopSection}>
      <div style={{ justifyItems: "center" }}>
        <div className={styles.shopPictureContainer}>
          <img
            className={styles.topImage}
            src={mobileImgShop}
            alt="Mobilt skjermbilde av Woolit Shop"
          />
          <img
            className={styles.bottomImage}
            src={mobileImageOppskrift}
            alt="Mobilt skjermbilde av Woolit Design Studio Pro"
          />
        </div>
        <div
          style={{
            color: "var(--whiteish)",
            textAlign: "center",
          }}
        >
          {t("landing.explore")}{" "}
          <a
            href="https://shop.woolit.no"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            Woolit Shop
          </a>{" "}
          <img src={arrow} alt="Pil"></img>{" "}
        </div>
      </div>
      <img
        className={styles.verticalLine}
        src={verticalLine}
        alt="Vannrett linje"
      />

      <div className={styles.shopDescriptionContainer}>
        <div
          style={{
            color: "var(--whiteish)",
            fontSize: "36px",
          }}
        >
          {t("landing.woolit shop lets you to earn from your hobby")}
        </div>
        <ul>
          <li>
            {t("landing.more creativity, less technicality and administration")}
          </li>
          <li>{t("landing.easy publishing from Design Studio")}</li>
          <li>
            {t(
              "landing.recipes automatically integrated with yarn package selection"
            )}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default WoolitShopSection;
